// ─────────────────────────────────────────────────────────────────────────────
// The dashboard CORE — one wiring, every window.
//
// Owner ruling 2026-07-31: the portrait phone app is a second SURFACE, not a
// fork. "Same panels, same endpoints, same gates, different arrangement."
// Everything a surface needs to be correct lives here; a surface supplies only
// layout. If you find yourself writing `fetch(` in a surface component, stop —
// that is the drift this module exists to prevent.
//
// Owned here: endpoints, poll cadence, auth idiom, payload types, the one clock,
// and the interaction GATES (activity drill-in, report answer, calendar day
// selection, timezone write).
// Owned by the surface: styles, JSX, arrangement.
// ─────────────────────────────────────────────────────────────────────────────

export { authHeaders, POLL_MS } from './authHeaders';
export { makeTimeFormatter } from './timeFormat';

// The nine endpoints, in the one plain-JS module BOTH surfaces read (the phone
// surface loads this exact file, copied verbatim into public/phone/ at build).
export {
  ACTIVITY, activityDetail, calendar, calendarDay, SETTINGS,
  DREAMSTATE, NOTES, REPORT_INDEX, REPORT_ANSWER, PULSE_SCHEDULE,
  OS_STRUCTURE, domainBoard,
} from './endpoints';

export { useActivity, REXY_LANE, GROWTH_LANE, ACTIVITY_KIND_LABEL, DETAIL_FIELDS, pad2, hhmm, nextPulseHour, pulseOutcome } from './useActivity';
export type { ActivityFeed, ActivityLane, DetailSlot, ActivityDetail, ActivityIndexResponse, ActivityRow } from './useActivity';

export { useNotes, NOTE_KIND_LABEL } from './useNotes';
export type { NotesFeed, NoteEntry, NoteHour, NotesView, NotesResponse } from './useNotes';

export { useReports } from './useReports';
export type { ReportsFeed, ReportEntry, ReportsView, ReportsGate, ReportWindowSpan, ReportsResponse } from './useReports';

export { useDreamstate } from './useDreamstate';
export type { DreamstateFeed, DreamEntry, DreamNight, DreamRun, DreamstateGate, DreamstateView, DreamstateResponse } from './useDreamstate';

export { useDreamReview, REST_LABEL, DREAM_REVIEW, DREAM_REVIEW_DECISION, own } from './useDreamReview';
export type { DreamReviewFeed, DreamCandidate, DreamReviewGroup, DreamKeyMoment, DreamReviewView, DreamDecision, DreamNotice } from './useDreamReview';

export { useCalendar, dayKey } from './useCalendar';
export type { CalendarFeed, CalendarTab, DayCounts } from './useCalendar';

export { useClockSettings, ianaZones } from './useClockSettings';
export type { ClockSettingsFeed, ClockSaveState } from './useClockSettings';

export { usePulseSchedule } from './usePulseSchedule';
export type { PulseFeed, PulseRow, PulseSchedule, PulseScheduleResponse } from './usePulseSchedule';

export { useDomainSurface, slug } from './useDomainSurface';
export type { DomainSurfaceFeed, DomainRoot, DomainBoard, StructureAgent } from './useDomainSurface';
